// @ts-nocheck
import styled from 'styled-components';

export const InsightNavConfigStyled = styled.div`
  .reportingInsightsGroupItem__config {
    &-box {
      align-items: center;
      display: flex;
      justify-content: space-between;
    }

    &-element {
      display: flex;
      flex-direction: column;

      &Title {
        all: initial;
        color: ${props => props.theme.uiColors.selectorLabel};
        font-family: ${props => props.theme.fontRegular};
        font-size: ${props => props.theme.fontSizeXS};
        letter-spacing: 0;
        line-height: 16px;
      }

      &Content {
        display: flex;
        gap: 16px;
        height: fit-content;
        margin-top: 16px;
      }
    }

    &-data {
      display: flex;
      gap: 32px;
    }
  }
`;
